import { render } from "./index.vue?vue&type=template&id=07078a5a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=07078a5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07078a5a"

export default script